import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import ROUTES from '../../routes';
import api from './../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

function AddCategory() {
    const formRef = useRef(null);
    const navigate = useNavigate();

    const [title, setTitle] = useState('');
    const [parentId, setParentId] = useState('');
    const [parentCategories, setParentCategories] = useState([]);
    const [img, setImg] = useState(null);
    const [imgPreview, setImgPreview] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {
            setTitle('');
            setParentId('');
            setImg(null);
            setImgPreview(null);

            $(form)
                .find('.is-valid, .is-invalid')
                .removeClass('is-valid is-invalid');

            $(form)
                .find('label.error, .invalid-feedback')
                .remove();

            const payload = { title, parent_id: parentId || null, img };

            console.log(payload);

            try {
                setSubmitting(true);
                const res = await api.post(
                    '/category/create',
                    payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                showToast('success', res.data.message, 'Success');
                navigate(ROUTES.CATEGORIES);
            } catch (err) {
                handleErrors(err);
            } finally {
                setSubmitting(false);
            }
        }
    };

    useEffect(() => {
        const fetchParentCategories = async () => {
            try {
                const res = await api.get('/category/list');
                if (res.status === 200) {
                    setParentCategories(res.data.categories || []);
                }
            } catch (err) {
                handleErrors(err);
            }
        };

        fetchParentCategories();

        const $ = window.jQuery;

        $.validator.addMethod('extension', function (value, element, allowedExtensions) {
            var fileName = value;
            var extension = fileName.split('.').pop().toLowerCase();
            return $.inArray(extension, allowedExtensions) !== -1;
        }, 'Invalid file type');

        if (formRef.current && $.fn.validate) {
            $(formRef.current).validate({
                rules: {
                    title: {
                        required: true,
                        maxlength: 200
                    },
                    parent_id: {
                        required: false
                    },
                    img: {
                        required: false,
                        extension: ['jpg', 'jpeg', 'png', 'svg', 'webp']
                    }
                },
                messages: {
                    title: {
                        required: "Please enter category title",
                        maxlength: "Title cannot exceed 200 characters"
                    },
                    img: {
                        extension: "Only jpg, jpeg, png, svg, webp allowed"
                    }
                },
                ignore: [],
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImg(file);
            setImgPreview(URL.createObjectURL(file));
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.CATEGORIES}>Categories</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.ADD_CATEGORY}>Add Category</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Add Category</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">
                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Title<sup style={{ color: 'red' }}>*</sup></label>
                                        <input
                                            name="title"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. SUVs"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Parent Category (optional)</label>
                                        <select
                                            name="parent_id"
                                            className="form-control"
                                            value={parentId}
                                            onChange={(e) => setParentId(e.target.value)}
                                        >
                                            <option value="">None</option>
                                            {parentCategories.map((category) => (
                                                <option key={category._id} value={category._id}>
                                                    {category.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label htmlFor="img" className="form-label">Image<sup style={{ color: 'red' }}>*</sup></label>
                                        <div className="input-group custom_file_input">
                                            <div className="form-file">
                                                <input
                                                    name="img"
                                                    type="file"
                                                    className="form-file-input form-control"
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                            {/* <span className="input-group-text">Upload</span> */}
                                        </div>
                                        {imgPreview && (
                                            <div className="mt-2">
                                                <img
                                                    src={imgPreview}
                                                    alt="Preview"
                                                    style={{ width: 100, height: 100, objectFit: 'contain' }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="pt-3">
                                    <button
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.CATEGORIES} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCategory;
